import { render, staticRenderFns } from "./FamousCommentMore.vue?vue&type=template&id=8f3e426a&"
import script from "./FamousCommentMore.vue?vue&type=script&lang=js&"
export * from "./FamousCommentMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports